export const ORG_QUERY = '/org';
export const ORG_USERS_QUERY = '/users';
export const ORG_ENGAGEMENTS_QUERY = '/org/engagements';
